import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./reducer/userSlice";
import mfaReducer from "./reducer/mfaSlice";
import leadColumnReducer from "./reducer/leadsColumnSlice";
import smartviewColumnReducer from "./reducer/smartViewsColumnSlice";
import usersColumnReducer from "./reducer/usersColumnSlice";
import activityColumnReducer from "./reducer/activityColumnSlice";
import columnOrderReducer from "./reducer/columnOrderSlice";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import { persistReducer, persistStore } from "redux-persist";

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "user",
    "mfa",
    "leadsColumn",
    "smartViewColumn",
    "usersColumn",
    "activityColumn",
    "columnOrder",
  ],
};

const rootReducer = combineReducers({
  user: userReducer,
  mfa: mfaReducer,
  leadsColumn: leadColumnReducer,
  smartViewColumn: smartviewColumnReducer,
  usersColumn: usersColumnReducer,
  activityColumn: activityColumnReducer,
  columnOrder: columnOrderReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);
